import { deserialize } from 'cerialize'

export class SpecialOfferModel {
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public prefix: string
	@deserialize public description?: string
	@deserialize public is_active?: boolean

	public get active(): string | undefined {
		return this?.is_active ? 'Активен' : 'Не активен'
	}
}
